import { ThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { createTheme } from '@mui/material/styles';
import NftCard from 'components/molecules/Card/NftCard';
import * as React from 'react';
import Media from 'react-media';
import MobileExplorePage from './FeedBody';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const GalleryBody = () => {
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box>
          <Media query="(max-width: 599px)">
            {matches =>
              matches ? (
                <MobileExplorePage />
              ) : (
                <Grid
                  container
                  style={{
                    gap: '40px',
                    maxWidth: '1300px',
                    justifyContent: 'start',
                  }}
                >
                  <Grid item>
                    <NftCard
                      splitWith="John"
                      price="0.11"
                      currency="BTC"
                      ownerName="Pops"
                      name="Reaver"
                      views={100}
                      image={''}
                      id={0}
                      poster={''}
                    />
                  </Grid>
                </Grid>
              )
            }
          </Media>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default GalleryBody;
